<template>
  <div>
    <modal class="modal-content" @close="$emit('close')">
      <h4 slot="title">
        {{ $t('timeZone') }}
      </h4>
      <section slot="body" class="body">
        <div class="img-wrapper">
          <img :src="require('@/assets/illustrations/earth.svg')" />
        </div>
        <dropdown
          id="timezone"
          v-model="chosenTimezone"
          editable
          auto-complete
          :title="$t('location')"
          show-all
          by-value
          dont-save
          :options="timezones"
          :dbname="'timezone'"
        />

        <a class="my-loc-btn" @click="findTimezone()">
          <img :src="require('@/assets/_desktop/_calendars/my-location.svg')" />
          My Location
        </a>
        <button class="clavo-button primary" @click="changeTimezone()">
          {{ $t('done') }}
        </button>
      </section>
    </modal>
  </div>
</template>

<script>
import EventBus from '@/EventBus'
import Modal from '@/components/Modal'
import Constants from '@/components/Constants'
import Parse from 'parse'
import Dropdown from '@/components/UI/Dropdown'
import ParseFunctions from '@/components/ParseFunctions'

export default {
  components: {
    Modal,
    Dropdown,
  },
  mixins: [Constants, ParseFunctions],
  props: {
    oldTimezone: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      timezones: [],
      chosenTimezone: null,
    }
  },
  computed: {},
  created() {
    this.chosenTimezone = this.oldTimezone
    this.timezones = this.$store.state.timezonesGlobal
  },
  methods: {
    async changeTimezone() {
      Parse.User.current().set('timezone', this.chosenTimezone)
      Parse.User.current().save()

      let res = await this.setUserSetting('timezone', this.chosenTimezone)

      if (res.status == 'ok') {
        this.$store.commit('setOneUserSetting', { name: 'timezone', value: this.chosenTimezone })
        this.$emit('change-timezone')
      } else {
        this.showServerError(res)
      }

      this.$emit('close')
    },
    findTimezone() {
      let moment = require('moment-timezone')
      let guessTimezone = moment.tz.guess(true) // ignoreCache = true
      this.chosenTimezone = guessTimezone
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-content {
  overflow-y: scroll;
  h4 {
    text-transform: capitalize;
  }
}
section {
  display: flex;
  flex-direction: column;
  margin: 0 84px;
  .img-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    img {
      margin-bottom: 36px;
      width: 240px;
    }
  }
  .my-loc-btn {
    font-family: $bold;
    align-self: center;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-top: 18px;
    padding: 8px;
    img {
      margin-right: 10px;
    }
    @include button-hover($blue, $white-lilac);
  }
  button {
    margin: 52px 0 30px;
  }
  @include respond-below(sm) {
    width: 100%;
    margin: 10px 0 30px 0;
  }
}
</style>
